<template>
  <v-dialog :value="value"
            persistent>
    <div class="d-flex justify-center align-center">
      <v-progress-circular :size="90"
                           :width="8"
                           color="kbWhite"
                           indeterminate/>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  ::v-deep .v-dialog {
    box-shadow: none!important;
    overflow-y: hidden!important;
  }
</style>
